import React from "react";
import { Icon } from "rhombus-react";

export default function IconCell({
	onClick,
	iconName,
}){
	return (
		<td className="icon-cell" onClick={onClick}>
			<Icon name={iconName} />
		</td>
	);
}

IconCell.displayName = "IconCell";
